"use client";

import React, { useMemo } from "react";
import CountryPhonePrompt from "./CountryPhonePrompt";
import { useLanguage } from "@/contexts/LanguageContext";
import { getStrings } from "@/i18n/dictionaries";

/**
 * Component to display when user tries Egypt MoMo with non-EG phone.
 * Wrapper around CountryPhonePrompt with Egypt-specific configuration.
 */
export default function EgyptPhonePrompt({
  onClose,
  onSwitchToStripe,
  detectedPhone,
  authPhone,
  profilePhone,
  profileCountry,
  selectedPaymentCountry,
}) {
  const { locale } = useLanguage();
  const t = useMemo(() => getStrings(locale, "payment"), [locale]);
  const egConfig = {
    title: t.egypt_phone_title,
    requiredPrefix: "+20",
    requiredCountryName: "Egypt",
  };

  return (
    <CountryPhonePrompt
      onClose={onClose}
      onSwitchToStripe={onSwitchToStripe}
      onSwitchToBankTransfer={null}
      detectedPhone={detectedPhone}
      authPhone={authPhone}
      profilePhone={profilePhone}
      profileCountry={profileCountry}
      selectedPaymentCountry={selectedPaymentCountry}
      config={egConfig}
    />
  );
}
